import * as React from "react";
import { connect } from "react-redux";
import ExpiryReturns from "../../screens/ExpiryReturns";

import {
  ExpiryReturn,
  ExpiryReturnsSelectedPage,
  ExpiryReturnsSearch,
  ExpiryReturnsSearchSelectedPage,
  ExpiryReturnView,
  FilterSearchExpiryUser,
  fltrExpiryUserPagetn,
} from "./action";

class ExpiryReturnsContainer extends React.Component {
  render() {
    return (
      <ExpiryReturns
        ExpiryReturn={this.props.ExpiryReturn}
        ExpiryReturnDtlsList={this.props.ExpiryReturnDtlsList}
        ExpiryReturnlsCount={this.props.ExpiryReturnlsCount}
        ExpiryReturnsSelectedPage={this.props.ExpiryReturnsSelectedPage}
        ExpiryReturnsSearch={this.props.ExpiryReturnsSearch}
        ExpiryReturnsSearchSelectedPage={
          this.props.ExpiryReturnsSearchSelectedPage
        }
        ExpiryReturnSearchList={this.props.ExpiryReturnSearchList}
        ExpiryReturnSearchCount={this.props.ExpiryReturnSearchCount}
        ExpiryReturnView={this.props.ExpiryReturnView}
        ExpiryReturnls={this.props.ExpiryReturnls}
        ExpiryReturnDtlsCount={this.props.ExpiryReturnDtlsCount}
        FilterSearchExpiryUser={this.props.FilterSearchExpiryUser}
        fltrExpiryUserPagetn={this.props.fltrExpiryUserPagetn}
        expiryUserFilterList={this.props.expiryUserFilterList}
        expiryUserFilterCount={this.props.expiryUserFilterCount}
      />
    );
  }
}

function bindAction(dispatch) {
  return {
    ExpiryReturn: () => {
      dispatch(ExpiryReturn());
    },
    ExpiryReturnsSelectedPage: (value) => {
      dispatch(ExpiryReturnsSelectedPage(value));
    },
    ExpiryReturnsSearch: (value) => {
      dispatch(ExpiryReturnsSearch(value));
    },
    ExpiryReturnsSearchSelectedPage: (value) => {
      dispatch(ExpiryReturnsSearchSelectedPage(value));
    },
    ExpiryReturnView: (value) => {
      dispatch(ExpiryReturnView(value));
    },
    FilterSearchExpiryUser: (value) => {
      dispatch(FilterSearchExpiryUser(value));
    },
    fltrExpiryUserPagetn: (value) => {
      dispatch(fltrExpiryUserPagetn(value));
    },
  };
}

const mapStateToProps = (state) => {
  return {
    ExpiryReturnDtlsList: state.ExpiryReturnsReducer.ExpiryReturnDtlsList,
    ExpiryReturnlsCount: state.ExpiryReturnsReducer.ExpiryReturnlsCount,

    ExpiryReturnSearchList: state.ExpiryReturnsReducer.ExpiryReturnSearchList,
    ExpiryReturnSearchCount: state.ExpiryReturnsReducer.ExpiryReturnSearchCount,

    ExpiryReturnDtlsCount: state.ExpiryReturnsReducer.ExpiryReturnDtlsCount,
    ExpiryReturnls: state.ExpiryReturnsReducer.ExpiryReturnls,

    expiryUserFilterList: state.ExpiryReturnsReducer.expiryUserFilterList,
    expiryUserFilterCount: state.ExpiryReturnsReducer.expiryUserFilterCount,
  };
};

export default connect(mapStateToProps, bindAction)(ExpiryReturnsContainer);
